import React, { ReactElement } from "react";

import { salutationTranslation } from "shared/lib/constants";
import { safeFormatMessage } from "shared/lib/functions";

type FullNameProps = {
  intl: any;
  person: PersonType;
};

type PersonType = {
  givenName: string;
  surname: string;
  namePrefix: string;
};

function FullName(nameObj: FullNameProps): ReactElement {
  const { intl, person } = nameObj;

  if (!person.givenName && !person.surname) {
    return <> &quot;-&quot; </>;
  }

  return (
    <>
      {person.surname &&
        `${safeFormatMessage({
          intl,
          id: salutationTranslation[person.namePrefix],
          fallback: person.namePrefix,
        })} ${person.givenName || ""} ${person.surname}`}
      {!person.surname &&
        `${safeFormatMessage({
          intl,
          id: salutationTranslation[person.namePrefix],
          fallback: person.namePrefix,
        })} ${person.givenName}`}
    </>
  );
}

export default FullName;
